var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"segmented-control"},[_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item",class:{ selected: item == _vm.value },on:{"click":function($event){return _vm.selectItem(index)}}},[_c('div',{attrs:{"data-text":_vm.labels ? _vm.labels[index] : item}})])}),_vm._v(" "),_c('div',{staticClass:"pointer",style:({
            transform: _vm.pointerTransform
        })},[_c('div',{style:({
                width: 100 / _vm.items.length + '%',
            })})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }